import { SignUpConfirm } from '@app/auth/components/SignUpConfirm';

export const SignUpConfirmPage = () => {
  return <SignUpConfirm />;
};
